import { nutritionFormAdapter } from "../form-adapter";
export const chocolateNutritionAdapter = nutritionFormAdapter("chocolate");
